import React, { useEffect, useState } from "react";
import ReactDataGrid from "react-data-grid";
import { Container, Button, Modal, Dropdown, Grid, Pagination, Icon, Confirm, Input, Table, Segment, Dimmer, Loader } from 'semantic-ui-react'
import _ from "lodash";
import moment from 'moment'
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { getShift } from '../../Redux/Actions/ShiftAction'
import { getDutyRoster, saveDutyRoster } from '../../Redux/Actions/DutyRosterAction'
import AppLoader from '../../Components/AppLoader';

const DutyRosterCreate = ({ history }) => {

   const authToken = localStorage.getItem('accessToken');
   const dispatch = useDispatch()

   useEffect(() => {
      dispatch(getShift(toast, authToken))
      dispatch(getDutyRoster(toast, authToken, setDutyRosterData))
   }, [])

   // const dutyRosterData = useSelector(state => state.dutyRosterReducer.dutyRosterPayload)
   const isLoading = useSelector(state => state.loadingReducer.loadingPayload)
   const [shift, setShift] = useState(1)
   const [shiftYear, setShiftYear] = useState(moment().format('YYYY'))
   const [shiftMonth, setShiftMonth] = useState(JSON.parse(moment().add(1, 'M').format("M")))
   const [dutyRosterData, setDutyRosterData] = useState([])
   const [searchInput, setSearchInput] = React.useState('');
   const [actionMode, setActionMode] = React.useState('')
   const shiftData = useSelector(state => state.shiftReducer.shiftPayload)
   const shiftList = shiftData && shiftData.filter(item => item.status === 'A').map(data => {
      return {
         key: data.id,
         value: data.id,
         text: data.name,
      }
   })

   const yearOptions = [
      { key: moment().add(-1, 'y').format('YYYY'), value: moment().add(-1, 'y').format('YYYY'), text: moment().add(-1, 'y').format('YYYY') },
      { key: moment().format('YYYY'), value: moment().format('YYYY'), text: moment().format('YYYY') },
      { key: moment().add(1, 'y').format('YYYY'), value: moment().add(1, 'y').format('YYYY'), text: moment().add(1, 'y').format('YYYY') },
   ]
   const monthOptions = moment.months().map((item, index) => {
      return {
         key: index,
         value: index + 1,
         text: item
      }
   })

   // const rows = postAgainstShift && postAgainstShift.filter(item => (
   //    item.name.toString().includes(searchInput)
   // ));

   const dateforNumber = moment(`${shiftYear}-${shiftMonth}`, "YYYY-MM").daysInMonth();
   const monthDays = []
   _.times(dateforNumber, (i) => { monthDays.push(i + 1) })

   const columns = [
      { key: "id", name: "ID", frozen: true },
      { key: "title", name: "Post Name", frozen: true },
   ];

   const monthDateArrey = monthDays.map(item => {
      return {
         key: `day_${item}`,
         name: `Day${item}`,
         editable: true
      }
   })

   const columnData = [...columns, ...monthDateArrey]

   const [postAgainstShift, setPostAgainstShift] = useState({ rows: [] })

   const onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
      setPostAgainstShift(data => {
         const rows = data.rows.slice();
         for (let i = fromRow; i <= toRow; i++) {
            rows[i] = { ...rows[i], ...updated };
         }
         return { rows };
      });
   };

   const handleShiftSelect = (shiftId) => {
      const shiftPost = dutyRosterData && dutyRosterData.filter(item => item.id === shiftId)
      setPostAgainstShift({
         rows: shiftPost[0].shift_post.map(item => {
            return {
               id: item.id,
               title: item.name,
               shiftId: shiftId,
               shiftMonth: moment(`${shiftYear}-${shiftMonth}`).format('YYYY-MM'),
            }
         })
      })
   }

   const handleSubmit = () => {
      console.log(postAgainstShift)
      dispatch(saveDutyRoster(postAgainstShift, toast, authToken))
   }
   

   return (
      <Container fluid>
         <Grid>
            <Grid.Column floated='left' width={8}>
               <h2 style={{ fontSize: 22, color: 'rgba(0,0,0,0.87)', fontWeight: 400 }}>Shift Management</h2>
            </Grid.Column>
            <Grid.Column floated='right' width={8}>
               <Button
                  floated='right'
                  positive
                  onClick={handleSubmit}>
                  <Icon name='save outline' />
                  Save Record
               </Button>
               <Button
                  floated='right'
                  primary
                  onClick={() => history.push('duty-roster')}>
                  <Icon name='reply' />
                  Back
               </Button>
            </Grid.Column>
         </Grid>
         <Grid className="table-action-header">
            <Grid.Column floated='left' width={10}>
               <Grid>
                  <Grid.Column floated='left'>
                     <Dropdown
                        placeholder='Year'
                        selection
                        search
                        options={yearOptions}
                        defaultValue={shiftYear}
                        onChange={(e, { value }) => setShiftYear(value)}
                     />
                  </Grid.Column>
                  <Grid.Column floated='left'>
                     <Dropdown
                        placeholder='Month'
                        selection
                        search
                        options={monthOptions}
                        defaultValue={shiftMonth}
                        onChange={(e, { value }) => setShiftMonth(value)}
                     />
                  </Grid.Column>
                  <Grid.Column floated='left'>
                     <Dropdown
                        placeholder='Shift'
                        selection
                        search
                        options={shiftList}
                        defaultValue={shift}
                        onChange={(e, { value }) => (setShift(value), handleShiftSelect(value))}
                     />
                  </Grid.Column>
               </Grid>
            </Grid.Column>
            <Grid.Column floated='right' width={6}>
               <Input style={{ float: 'right' }}
                  icon='search'
                  placeholder='Search..'
                  value={searchInput}
                  onChange={e => setSearchInput(e.target.value)}
               />
            </Grid.Column>
         </Grid>
         {isLoading && isLoading.status ? <AppLoader /> :
            <ReactDataGrid
               columns={columnData}
               rowGetter={i => postAgainstShift.rows[i]}
               rowsCount={postAgainstShift.rows.length}
               onGridRowsUpdated={onGridRowsUpdated}
               enableCellSelect={true}
            />}
      </Container>
   );
}

export default DutyRosterCreate